"use client";

import Link from "next/link";
import Header from "./Header";

export default function Error({ error, reset }) {
	return (
		<>
			<Header
				altText={`500`}
				title={`FactoryCat - 500 Error`}
				paragraph={`Could not find requested resource`}
			/>
			<div className='standard-page'>
				<div>
					<h1>Our apologies! It seems the content you are looking for has been moved. </h1>
					<p>The good news is you can find it by visiting our home page at the link below.</p>
					<Link href='#' onClick={() => window.location.reload()}>
						Try Again
					</Link>
				</div>
			</div>
		</>
	);
}
